// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"95e66441","171":"3c8bd5bc","229":"ce14d51c","293":"75f7e76c","332":"c481f23c","344":"71a92608","453":"18ad5954","490":"da01e4b2","521":"86d9d567","693":"74a10c2a","766":"a6a0fd7b","770":"63d09a3c","897":"eddb72b2"}[chunkId] + ".chunk.js";
};